import { Injectable } from '@angular/core';
import {Headers, Http, RequestOptions} from '@angular/http';
import {environment} from '../../../environments/environment';
import {CookieService} from 'ngx-cookie';
declare var DDP_ENV: any;
@Injectable({
  providedIn: 'root'
})
export class DeviceTypeService {
  readonly baseURL = DDP_ENV.deviceTypeBaseUrl;


  constructor(private _http: Http, private cookieService: CookieService) { }

  getAllDeviceTypes() {
    console.log('Inside get deviceType');
    return this._http.get(this.baseURL + '/device/devicetype', this.buildHeaders());
  }

  /* Construct a common header */
  private buildHeaders(): any {
    const headers = new Headers({'Authorization': 'Bearer ' + this.cookieService.get('ecare_access_token')});
    return new RequestOptions({ headers: headers });
  }
}
